// @flow
import React, { Component } from "react";

import Typography from "@material-ui/core/Typography";
import { ColorSchema } from "../../global/types/scss";

class LivenessCheck extends Component<*> {
  render(): React$Element<*> {
    let block = null;
    if (!!this.props.liveness) {
      if (this.props.liveness.error) {
        block = (
          <span className="fail-label">
            {"Error - " + this.props.liveness.error}
          </span>
        );
      } else {
        if (parseFloat(this.props.liveness.quality) < 0.5) {
          block = (
            <span className="fail-label">
              {"Error - The image quality is not good enough."}
            </span>
          );
        } else {
          if (parseFloat(this.props.liveness.probability) < 0.5) {
            block = <span className="fail-label">Failed</span>;
          } else {
            block = <span className="success-label">Passed</span>;
          }
        }
      }
    }

    if (!this.props.liveness) {
      return null;
    } else {
      return (
        <Typography
          variant="subheading"
          className="form-text blinker"
          style={{ color: ColorSchema("primary") }}
        >
          <span>Liveness Check: </span>
          {block}
        </Typography>
      );
    }
  }
}

export default LivenessCheck;



// WEBPACK FOOTER //
// ./src/conference/component/LivenessCheck.js